module.exports = __webpack_public_path__ + "img/e7b1eaf.jpg";